import React, { useState } from 'react';
import axios from 'axios';

function AuthPage({ onLogin }) {
    const [mode, setMode] = useState('login');  // login by default
    const [form, setForm] = useState({ username: '', password: '' });
    const [message, setMessage] = useState('');
    const [status, setStatus] = useState(true)  // true if OK status, false if bad

    const handleChange = event => {
        setForm({ ...form, [event.target.name]: event.target.value });
    };

    const handleSubmit = async () => {
        try {
            const url = mode === 'login' ? '/api/auth/login' : '/api/auth/register';
            const res = await axios.post(url, form);

            setMessage(res.data.message);
            setStatus(true);
            if (mode === 'login') { onLogin(res.data.role); }
        } catch (error) {
            setStatus(false);
            if (error.response) { setMessage(error.response.data.message); }
            console.error(error);
        }
    };

    return (
        <div className="bg-gray-900 flex items-center justify-center h-screen">
        <div className="items-center bg-gray-800 p-4 rounded">
            <div className="flex items-center gap-2 bg-gray-800 rounded">
                <input name="username" placeholder="Username" onChange={handleChange}
                       className="bg-gray-700 text-gray-300 placeholder-gray-400 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-green-500 w-40"/>
                <input type="password" name="password" placeholder="Password" onChange={handleChange}
                       className="bg-gray-700 text-gray-300 placeholder-gray-400 px-3 py-2 rounded focus:outline-none focus:ring-2 focus:ring-green-500 w-40"/>
                <button onClick={handleSubmit}
                        className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 px-4 rounded ml-2">
                    {mode === 'login' ? 'SIGN IN' : 'SIGN UP'}
                </button>
            </div>
            <p className="flex items-center text-gray-400 text-sm mt-2 gap-1">
                {mode === 'login' ? "Don't have an account? " : "Already registered? "}
                <button onClick={() => setMode(mode === 'login' ? 'register' : 'login')}>
                    Switch to {mode === 'login' ? 'Register' : 'Login'}
                </button>
            </p>
            <p className="mt-1" style={status ? {color: 'green'} : {color: 'red'}}>{message}</p>
        </div>
        </div>
    );
}

export default AuthPage